module.exports = __webpack_public_path__ + "img/e68646b3587e90a1f0bffd252f890181.png";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/images/teaser.png
// module id = 44
// module chunks = 0